<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
         <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <router-link :to="{name:'首頁'}" class="breadCrumb_no" title="首頁">首頁</router-link>
        <router-link :to="{name:'營業據點'}"><span>聯絡我們</span></router-link>
        <router-link :to="{name:'聯絡方式'}"><span>聯絡方式</span></router-link>
      </div>

      <h2 class="titleA">聯絡方式</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'營業據點'}" class="menu_on0">聯絡我們</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2313','http://www.ptotinc.com/','0','','2315')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2313"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'營業據點'}" class="menu_on0">營業據點</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'聯絡方式'}" class="menu_on2">聯絡方式</router-link>
              </ol>

            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">

          <form method="POST" action="portal_c2_cnt.php?owner_num=c2_38777&button_num=c2&folder_id=2315&search_type=1">

            <div class="searchbar">
              <ul>
                <li>

                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input tabindex="63" name="search_word" type="text" class="input" value="" />
                  <input tabindex="64" name="search_b1" type="submit" class="btn" value="查詢" />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38777&button_num=c2&folder_id=2315&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>
          <div class="cate_info">
            <div class="cate_info...">
              <div>
                <div id="contact...">
                  <div class="contact_c">&nbsp;</div>

                  <div class="ul_1">
                    <h1><span style="color: rgb(0, 102, 204);">業務窗口</span></h1>

                    <p>聯絡人：陳先生<br />
                      電話：+886-3-211-5526 #8168<br />
                      信箱：steven.chen@ptotinc.com<br />                     
                      <br />
                      聯絡人：王小姐<br />
                      電話：+886-3-211-5526 #8118<br />
                      ​信箱：tracy.wang@ptotinc.com</p>

                    <h1><span style="color: rgb(0, 102, 204);">人事窗口</span></h1>

                    <p>聯絡人：劉小姐<br />
                      電話：+886-3-211-5526 #8502<br />
                      &nbsp;</p>
                  </div>

                  <div style="display: none;">
                    <form action="portal_d2.php?owner_num=d2_32928&amp;button_num=d2" method="POST" name="F3"
                      onsubmit="return d2_check();">
                      <ul>
                        <li class="must_r"><b>姓名：</b><input id="input_name" name="input_name" type="text" value="" />
                          <input checked="checked" id="sex" name="sex" type="radio" value="先生" /> 先生 <input id="sex"
                            name="sex" type="radio" value="小姐" /> 小姐</li>
                        <li class="must_r"><b>Email：</b> <input id="email" name="email" size="50" type="text"
                            value="" /></li>
                        <li><b>聯絡電話：</b><input id="tel" maxlength="18" name="tel" type="text" value="" /></li>
                        <li class="must_r"><b>標題：</b><input id="title" name="title" type="text" value="" /></li>
                        <li class="must_r"><b>聯絡內容：</b><textarea cols="50" id="content" name="content"
                            rows="7"></textarea></li>
                        <li><b>認證碼：</b><img src="https://x.webdo.cc/images/check_num/55.jpg" /> <input id="check_num"
                            name="check_num" size="7" type="text" /> <input name="check_img" type="hidden" value="55" />
                        </li>
                        <li><b>&nbsp;</b><input id="b1" name="b1" type="submit" value="留言送出" /></li>
                      </ul>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul id="c_list">
          </ul>




          <br><br>
          <p style="text-align:center;">
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'information',
  data () {
    return {
      isAboutPage: true
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/contactus/Information.vue